MenuSeparatorTemplate = require "../templates/menu-separator"

module.exports = ->
  element: MenuSeparatorTemplate()
  separator: true
